import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard2";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconoDB from "assets/images/icons/icono_db.ico";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function CargaRdsCuenta(props: any) {
  console.log("props....", props);
  const [blocking, setBlocking] = React.useState(false);
  const [cargaRds, setCargaRds] = useState({});
  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      try {
        const data = await fetchData(url, context, {
          action: "carga-db-cpu-load",
          cuenta: [props.cuenta],
        });
        // console.log("data.......", data);
        if (Array.isArray(data.rows[0]) || data.rows.length > 0) {
          for (let obj of data.rows) {
            setCargaRds(obj);
          }
        } else {
          throw new error("El dato no es array");
        }
      } catch (err) {
        console.log("Error al obtener datos", err);
      } finally {
        setBlocking(false);
      }
    };
    catData();
  }, []);

  return (
    <Grid>
      {blocking ? (
        <AppLoading titleCustom={"Loading " + props.cuenta} />
      ) : (
        <MDBox mb={4} ml={0}>
          <ComplexStatisticsCard
            color="warning"
            icon={<img src={iconoDB} />}
            title={<b>{`Carga RDS ${cargaRds.cuenta}`}</b>}
            count={
              "CPU: " +
              cargaRds["avg_cpu"] +
              "%" +
              "\n" +
              "|" +
              "\n" +
              "LOAD: " +
              cargaRds["avg_load"] +
              "%"
            }
            percentage={{
              color: "success",
              amount: cargaRds["instance_count"],
              label: "Intancias RDS",
            }}
          />
        </MDBox>
      )}
    </Grid>
  );
}

export default CargaRdsCuenta;
